import { PipelineConfig } from '../../dashboard-config';
import type { DashboardConfig } from '../types';
import { useDashboardConfigForm } from '../hooks/useDashboardConfigForm';
import { ConfigDialogShell } from './ConfigDialogShell';

interface PipelineValueTileConfigDialogProps {
  open: boolean;
  onClose: () => void;
  dashboardConfig: DashboardConfig;
  availableStages: string[];
  onSave: (config: DashboardConfig) => Promise<void>;
  reloadConfig: () => Promise<DashboardConfig>;
}

export function PipelineValueTileConfigDialog({
  open,
  onClose,
  dashboardConfig,
  availableStages,
  onSave,
  reloadConfig,
}: PipelineValueTileConfigDialogProps) {
  const { form, values, patch, submit, saving, error } = useDashboardConfigForm({
    open,
    onClose,
    dashboardConfig,
    onSave,
    reloadConfig,
  });
  return (
    <ConfigDialogShell
      open={open}
      title="Configure Pipeline Value Tile"
      onClose={onClose}
      onSave={submit}
      saving={saving}
      saveLabel={form.saveLabel('Save')}
      banner={form.banner}
      error={error}
      note={
        form.field('pipelineStages', {
          format: (stages) => (stages.length ? stages.join(', ') : 'no stages'),
        }).helperText
      }
    >
      <PipelineConfig
        selectedStages={values.pipelineStages}
        availableStages={availableStages || []}
        onChange={(stages) => patch({ pipelineStages: stages })}
        variant="compact"
      />
    </ConfigDialogShell>
  );
}
